import { getPath } from '@/router/common'

const baseUrl = {
  title: '运单修改日报表',
  path: 'ChangeClassReport'
}
export default [
  {
    path: getPath('WaybillChangeRecord', baseUrl),
    name: 'ChangeClassReport_WaybillChangeRecord',
    component: () => import(/* webpackChunkName: "ChangeClassReport_WaybillChangeRecord" */ '@/views/changeClassReport/waybillChangeRecord/index.vue'),
    meta: {
      title: '运单修改日报表'
    }
  },
  {
    path: getPath('OperationLog', baseUrl),
    name: 'ChangeClassReport_OperationLog',
    component: () => import(/* webpackChunkName: "ChangeClassReport_OperationLog" */ '@/views/changeClassReport/operationLog/index.vue'),
    meta: {
      title: '操作日志报表'
    }
  },
  {
    path: getPath('SMabnormal', baseUrl),
    name: 'ChangeClassReport_SMabnormal',
    component: () => import(/* webpackChunkName: "ChangeClassReport_SMabnormal" */ '@/views/changeClassReport/sMabnormal/index.vue'),
    meta: {
      title: 'PDA扫码异常报表'
    }
  },
  {
    path: getPath('SystemChangeRecord', baseUrl),
    name: 'ChangeClassReport_SystemChangeRecord',
    component: () => import(/* webpackChunkName: "ChangeClassReport_SystemChangeRecord" */ '@/views/changeClassReport/systemChangeRecord/index.vue'),
    meta: {
      title: '修改日报表'
    }
  },
  {
    path: getPath('LoginLog', baseUrl),
    name: 'ChangeClassReport_LoginLog',
    component: () => import(/* webpackChunkName: "ChangeClassReport_LoginLog" */ '@/views/changeClassReport/loginLog/index.vue'),
    meta: {
      title: '登录日志报表'
    }
  }
]
